import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { getCookie } from "../utils/helper";

const ProtectedRoute = ({ children }: { children: any }) => {
  const { itemCount } = useSelector((state: any) => state?.cartData);
  const location = useLocation();

  // if (!localStorage.getItem("yop-token")) {

  if (!getCookie("yop-token")) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  } else if (location.pathname == "/order-details" || location.pathname =="/order-details/") {
    return children;
  } else if ( itemCount == 0 && (location.pathname == "/checkout" || location.pathname ==  "/checkout/") ) {
    return <Navigate to="/menu" state={{ from: location }} replace />;
  }
  return children;
};

export default ProtectedRoute;
